import { NavLink } from 'react-router-dom';
import BannerPhone from '../components/BannerPhone';

export default function Menu() {
  return (
    <div className='menu-container'>
      <BannerPhone />

      <main className='menu-main'>
        <ul className='menu__list'>
          <li
            className='navigation__item menu__item navigation__item menu__item--1 heading-menu'
            id='head'
          >
            <NavLink to='/'>Accueil</NavLink>
          </li>
          <li className='navigation__item menu__item navigation__item menu__item--2 heading-menu'>
            <NavLink to='/yoga'>Yoga</NavLink>
          </li>
          <li className='navigation__item menu__item navigation__item menu__item--3 heading-menu'>
            <NavLink to='/meditation'>Méditation</NavLink>
          </li>
          <li className='navigation__item menu__item navigation__item menu__item--4 heading-menu'>
            <NavLink to='/stages-et-retraites'>Stages & retraites</NavLink>
          </li>
          <li className='navigation__item menu__item navigation__item menu__item--5 heading-menu'>
            <NavLink to='/qui-sommes-nous'>Qui sommes-nous?</NavLink>
          </li>
          {/* <li className='navigation__item menu__item navigation__item menu__item--6 heading-menu'>
            <NavLink to='/articles'>Articles</NavLink>
          </li> */}
        </ul>
      </main>

      <footer className='menu-footer'>
        <img src='/img/wavywave.webp' alt='vague de décoration' className='menu__bottom' />
      </footer>
    </div>
  );
}
